import React, { useEffect, useState } from "react";
import AppTabs from "../../components/appTabs/appTabs";
import Authors from "../Authors/Authors";
import GenreList from "../Genre/GenreList";
import News from "../News/News";

const InfoCenter = () => {
  const [activeTab, setActiveTab] = useState("authors");
  const [tabs, setTabs] = useState([]);

  //* use effects
  useEffect(() => {
    let _tabs = [];

    _tabs.push({
      title: "Authors",
      value: "authors",
    });

    _tabs.push({
      title: "Genres",
      value: "genres",
    });

    _tabs.push({
      title: "News",
      value: "news",
    });

    setTabs([..._tabs]);
  }, []);

  //* builders
  const BuildTabViews = () => {
    switch (activeTab) {
      case "authors":
        return <Authors />;
      case "genres":
        return <GenreList />;
      case "news":
        return <News />;
      default:
        return <></>;
    }
  };

  //* methods

  return (
    <div className="tabs-page">
      <div className="views">{tabs?.length && BuildTabViews()}</div>

      <div className="tabs">
        <AppTabs
          tabs={tabs}
          activeTab={tabs.findIndex((tab) => tab.value === activeTab)}
          handleTabChange={(index) => {
            setActiveTab(tabs[index].value);
          }}
        />
      </div>
    </div>
  );
};

export default InfoCenter;
